import React, { Component } from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {
    prosNotificationShow,
    prosPopupClose
} from "../prodect/ProsPopup";
import RenderReport from "./RenderReport";
import {
    ATTR_OBJ_ID,
    ATTR_OBJ_STATE, ATTR_OBJ_TYPE, ATTR_UPDATED_MS_I,
    OBJ_STATE_ACT, OBJ_TYPE_ITM, OBJ_TYPE_ITM_OBS, OBJ_TYPE_LST,
    prosLogClearDt,
    prosLogDt,
} from "../prodect/ProsConnect";
import LoadingAnimation from "../components/LoadingAnimation";
import BasicButton from "../components/BasicButton";
import * as projectLoader from "../prodect/ProjectLoader";
import {getItemTypeText, getUpdatedBy, getUpdatedTimeWithSecondsStr} from "../prodect/ProsCommonUi";
import Checkbox from "../components/Checkbox";
import BasicModal from "../components/BasicModal";

function hasUserPermissionRestoreDeleteForItem(item) {
    /*
    Käyttöoikeus / permission tietojen palauttamiseen:
    - tiedon poistaja ( updated_by) voi palauttaa omansa - kun nykyinen oikeus on "rajoitettu" ( role_repair ) tai korkeampi
    - admin voi palauttaa kenen tahansa poistaman tiedon
    */
    return prosConnect.hasPermissionTo("manageObj", item);
}

/**
 * Called when user selects or unselects restore checkbox
 * @param item  Item to be restored or cancel undelete
 */
function restoreItemSelected(item, reportParent){
    const reportObj = reportParent.props.report
    const objId = item[ATTR_OBJ_ID];
    const TEN_SECS_IN_MS = 10000; //10s = 10000ms

    const isUpdatedByParentAction = (it, parent) =>
        it[ATTR_UPDATED_MS_I] < parent[ATTR_UPDATED_MS_I]+TEN_SECS_IN_MS &&
        it[ATTR_UPDATED_MS_I] >= parent[ATTR_UPDATED_MS_I];
    const isRemovedState = (it) => (it && it[ATTR_OBJ_STATE] !== OBJ_STATE_ACT)
    const removeRestore = (it) => it.ui_toBeRestored = false
    const activateRestore = (it) => it.ui_toBeRestored = true

    if (!item || !reportParent) {
        // Avoid a crash just in case not provided but item has attribute ui_isRemoved
        return
    }
    item.ui_toBeRestored = !item.ui_toBeRestored
    if(item.ui_toBeRestored) {
        // item selected to be restored
        // When selected check upper hierarchy for Deleted items -> they will be added to list as well
        if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS || prosConnect.objClass(item) === OBJ_TYPE_ITM) {
            if(isRemovedState(reportObj)){
                // Undelete report object when undeleting item from a deleted report
                reportObj.ui_toBeRestored = true
            }
            if(prosConnect.objClass(item) === OBJ_TYPE_ITM){
                // OBS child item
                const parentObs = reportObj.obsList.find(obs =>
                    obs.obsObjList &&
                    obs.obsObjList.find(obj => obj[ATTR_OBJ_ID] === objId)
                );
                if(isRemovedState(parentObs)){
                    activateRestore(parentObs);
                }
            }
            // If OBS selected, we activate children that are
            // deleted within 10sec (== deleted by removing OBS)
            if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS){
                item.obsObjList
                    .filter(isRemovedState)
                    .filter(obj => isUpdatedByParentAction(obj, item))
                    .forEach(obj => activateRestore(obj));
            }
        }
        else if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_LST){
            // If selecting report, activate the children that are
            // deleted within 10sec (== deleted by removing Report)
            item.obsList
                .filter(isRemovedState)
                .filter(obs => isUpdatedByParentAction(obs, item))
                .forEach(obs => {
                    activateRestore(obs);
                    obs.obsObjList
                        .filter(isRemovedState)
                        .filter(obj => isUpdatedByParentAction(obj, obs))
                        .forEach(obj => activateRestore(obj));
                });
        }
    }
    else {
        // item unselected to be restored
        if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_LST){
            // If unselecting report, unselect the children too
            // as it does not make sense to restore children only (they can't be seen anywhere)
            item.obsList
                .filter(isRemovedState)
                .forEach(obs => {
                    removeRestore(obs);
                    if (obs.obsObjList) {
                        obs.obsObjList
                            .filter(isRemovedState)
                            .forEach(obj => removeRestore(obj));
                    }
                });
        }
        else if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS){
            // If unselecting OBS, we unselect the children too
            // It does not make sense to restore children only (they can't be seen anywhere)
            item.obsObjList
                .filter(isRemovedState)
                .forEach(obj => removeRestore(obj));
        }
    }
    // Notify parent to refresh selection count
    if (typeof reportParent.props.notifyRestoreItemsSelected === 'function') {
        reportParent.props.notifyRestoreItemsSelected()
    }
    // Refresh report to show change in parent checkboxes
    reportParent.refreshUi()
}

export function renderWithRestoreControls(normalElement, item, reportParent){
    const isRemovedState = item && item[ATTR_OBJ_STATE] !== OBJ_STATE_ACT
    let headerText = null
    const itemText = getItemTypeText(item)
    if(isRemovedState){
        headerText = "poistettu " + itemText
        const updatedBy = getUpdatedBy(item)
        const updatedStr = getUpdatedTimeWithSecondsStr(item, true)
        headerText += ' (' + updatedBy + ', ' + updatedStr + ')'
    }
    return <div key={"restore__" + item.obj_id} className={"restore-item"}>
        <div>
            {isRemovedState
                ? hasUserPermissionRestoreDeleteForItem(item)
                    ? <Checkbox
                        text={`Palauta ${headerText}`}
                        checked={!!item.ui_toBeRestored}
                        onChange={() => restoreItemSelected(item, reportParent)}
                    />
                    : <span className={"text-xs color-no"}>Ei oikeutta palauttaa</span>
                : <span className={"text-xs color-2nd"}>{"Aktiivinen " + itemText}</span> }
        </div>
        <div className={"list-view"}>{normalElement}</div>
    </div>
}


export default class ProjectDeletedDataRestore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isRestoring: false,
            dragState: false,
            restoreList: [],
            restoreCount: 0,
            uiList: []
        };
        this.hasSubscribedDataChanges = false
        this.deletedList = [];
        this.openConfirmationToRestore = this.openConfirmationToRestore.bind(this);
        this.restoreItemsProcess = this.restoreItemsProcess.bind(this);
    }

    /**
     * This is called when component rendered first time
     */
    componentDidMount() {
        if (projectLoader.loadCompleteProjectIfNeeded()) {
            // Home will close view and open agin after started to load project data
            return
        }
        let project = prosConnect.getActiveProject();
        if (project) {
            prosLogDt('Selected project:', project.getPid());
            this.refreshUi();
            this.hasSubscribedDataChanges = true;
            projectLoader.subscribeRefreshUiWhenDataChanged(false, "undelete",
                (who, change) => this.onProjectDataChanged(who, change))
        } else {
            prosConnect.prosLogErr('No project selected')
        }
        // TODO - missing help for this / undelete page
        //setHelpContext('DeletedDataRestore')
    }

    componentWillUnmount() {
        // console.log("ProjectDeletedDataRestore:componentWillUnMount()");
        if (this.hasSubscribedDataChanges) {
            projectLoader.unSubscribeRefreshUiWhenDataChanged("undelete")
        }
    }

    componentDidUpdate(){
        // console.log("ProjectDeletedDataRestore:componentDidUpdate()");
    }

    onProjectDataChanged(who, change) {
        // prosConnect.prosLogX('ProjectDeletedDataRestore:onProjectDataChanged() who:', who);
        this.updateUiList()
    }

    updateRestoreCount() {
        let restoreObjs = this.deletedList.filter(it => it.ui_toBeRestored)
        this.setState({restoreCount: restoreObjs.length})
    }

    async loadDeletedItems() {
        let project = prosConnect.getActiveProject();
        if (project) {
            this.deletedList = await prosConnect.awaitLoadObjectsDeleted(project.getPid())
            this.deletedList.forEach(item => {
                // Add a couple of essential params to render obs correctly
                item.ui_isOpen = true;
                item.ui_isHistoryItem = true;
                item.ui_removed = true;
            });
            this.updateUiList()
        }
    }

    updateUiList() {
        let project = prosConnect.getActiveProject()
        if (project) {
            this.setState({uiList: project.getDeletedUiList(this.deletedList)})
        }
    }

    async refreshUi() {
        prosLogClearDt("Restore refreshUi()");
        this.setState({
            isLoading: true,
        });
        try {
            await this.loadDeletedItems()
            prosLogDt("Loaded project deleted items for restore")
        } finally {
            this.setState({
                isLoading: false,
                loadingUpdates: false,
            })
            this.updateRestoreCount()
        }
    }

    notifFromReport(text, warning, dismissByUser) {
        prosNotificationShow(this, text, warning, dismissByUser)
    }
    
    hasPermissionToRestoreContent() {
        return prosConnect.hasPermissionTo("addContent", undefined, undefined, false);
    }
    
    hasCapacityToRestoreContent(isObs) {
        return prosConnect.getActiveProject().hasCapacityToAddItems(isObs);
    }

    openConfirmationToRestore(){
        const selectedItemsToBeRestored = this.deletedList.filter(it =>
            it.ui_toBeRestored && it[ATTR_OBJ_STATE] !== OBJ_STATE_ACT
        ).map(item => {
            let proposalItem = prosConnect.makeObjCopyForAws(item, false);
            proposalItem[prosConnect.ATTR_OBJ_STATE] = prosConnect.OBJ_STATE_ACT;
            return proposalItem;
        })
        const that = this;
        BasicModal('Palauta valitut tiedot',
        'Vahvista, että haluat palauttaa valitut tiedot (' + selectedItemsToBeRestored.length + 'kpl)',
        {
            action: async () => {
                await that.restoreItemsProcess(selectedItemsToBeRestored);
            }
        })
    }
    
    async restoreItemsProcess(selectedItemsToBeRestored){
        this.setState({
            isRestoring: true,
        })
        try {
            prosPopupClose();
            await prosConnect.getActiveProject()
                .awaitUpdateMultipleItemsChunks(selectedItemsToBeRestored, 200, false)
        }
        finally {
            // 2024-3-5 close undelete view when items been restored
            this.props.closeView(true)
        }
    }

    renderRestoreControl(){
        if (!this.hasPermissionToRestoreContent()) {
            return <div className="msg msg-warning"><p>Käyttäjällä ei oikeuksia palauttaa tietoja.</p></div>
        }
        if (!this.hasCapacityToRestoreContent(false)) {
            return <div className="msg msg-warning">
                <p>Projektin palvelutason kapasiteettirajoite ei salli tietojen palautusta.</p>
            </div>
        }
        if (this.state.isLoading) {
            return <LoadingAnimation size="lg" text="Ladataan osaprojektin poistettuja tietoja..."/>
        } else if (this.state.isRestoring) {
            return <LoadingAnimation size="lg" text="Palautetaan osaprojektin poistettuja tietoja..."/>
        }else if (this.state.uiList.length < 1) {
            return <div className="msg msg-info inline-flex"><p>Osaprojektissa ei ole poistettuja tietoja.</p></div>
        } else {
            return <>
                <h2>Valitse palautettavat tiedot</h2>
                {this.renderUiList()}
            </>
        }
    }

    renderPageFooter(){
        if(this.state.restoreCount < 1) return null
        return <footer className={"page-footer"}>
            <div className={"btn-set_center"}>
                <BasicButton
                    btnClass={"primary"}
                    label={"Palauta valitut tiedot (" + this.state.restoreCount + ")"}
                    action={this.openConfirmationToRestore}
                    btnType={"prompt"}
                />
            </div>
        </footer>
    }

    renderUiList() {
        if (this.state.isLoading || this.state.isRestoring || this.state.uiList.length < 1) {
            return null
        }
        let project = prosConnect.getActiveProject();
        if (!project.isProjectLoaded()) {
            return <h3> Ohjelmavirhe - projektin tietoja ei ole ladattu.</h3>
        } else {
            return this.state.uiList.map(
                    uiItem => <RenderReport
                        key={uiItem.obj_id}
                        report={uiItem}
                        notifyRestoreItemsSelected = {(restoreItems) => {this.updateRestoreCount()}}
                        refreshParentUi={this.refreshUi}
                        notif={this.notifFromReport}
                    />
                )
        }
    }

    render() {
        require('./assets/scss/views/List.scss')
        return <>
                <h1>Osaprojektin poistetut tiedot</h1>
                <section>
                    {this.renderRestoreControl()}
                </section>
                {this.renderPageFooter()}
            </>
    }
}
